var map = {
	"./bo.json": 73570,
	"./de.json": 26690,
	"./en.json": 40714,
	"./es.json": 11273,
	"./fi.json": 77936,
	"./fr.json": 89577,
	"./it.json": 14435,
	"./nb_NO.json": 89092,
	"./pt_BR.json": 55654,
	"./ro.json": 12412,
	"./si.json": 65993,
	"./ug.json": 65703,
	"./zh_Hans.json": 68455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22380;